import PageHeader from '../components/PageHeader';
import useDocumentMeta from '../hooks/useDocumentMeta';
import { pageMeta, uses } from '../data/site';
import styles from './Uses.module.scss';

function Uses() {
  useDocumentMeta(pageMeta['/uses']);

  return (
    <>
      <PageHeader
        eyebrow="Setup"
        title="Uses"
        intro="The hardware and software I reach for every day."
      />

      <div className={styles.groups}>
        {uses.map(({ id, title, items }) => (
          // Each group is labelled by its own heading, so the section has a
          // name in the accessibility tree.
          <section key={id} className={styles.group} aria-labelledby={`uses-${id}`}>
            <h2 id={`uses-${id}`} className={styles.groupTitle}>
              {title}
            </h2>
            <ul className={styles.items}>
              {items.map((item) => (
                <li key={item} className={styles.item}>
                  {item}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </>
  );
}

export default Uses;
